export class TramiteDto {
  constructor(data: any | undefined = undefined) {
    if (data != undefined) {

      this.id = data.id;
      this.nroCatastral = data.nroCatastral;
      this.calle = data.calle;
      this.numero = data.numero;
      this.piso = data.piso;
      this.depto = data.depto;
      this.barrio = data.barrio;
      this.codigoPostal = data.codigoPostal;
      this.cuitEmpresa = data.cuitEmpresa;
      this.superficieTotal = data.superficieTotal;
      this.superficieCubierta = data.superficieCubierta;
      this.razonSocial = data.razonSocial;

      this.habilitacionVigente = data.habilitacionVigente;
      this.nroHabilitacion = data.nroHabilitacion;
      this.fechaHabAprobada = data.fechaHabAprobada;
      this.fechaVencimientoHab = data.fechaVencimientoHab;
      this.bajaAdministrativa = data.bajaAdministrativa;

      this.ubicacionFisica = data.ubicacionFisica;
      this.riesgo = data.riesgo;
      this.tramiteEstado = data.tramiteEstado;
      this.estadoHabilitacion = data.estadoHabilitacion;
      this.tramiteActividades = data.tramiteActividades;
      this.tramiteActividadesNoEjercidas = data.tramiteActividadesNoEjercidas;
      this.tramiteSocios = data.tramiteSocios;
    }
  }

  public id: number = 0;
  public nroCatastral: string = "";
  public riesgo: string = "";
  public tramiteEstado: string = "";
  public estadoHabilitacion: string = "";
  public ubicacionFisica: string = "";
  public calle: string = "";
  public numero: string = "";
  public piso: string = "";
  public depto: string = "";
  public barrio: string = "";
  public codigoPostal: string = "";
  public cuitEmpresa: string = "";
  public superficieTotal: number = 0;
  public superficieCubierta: number = 0;
  public razonSocial: string = "";
  
  public habilitacionVigente: boolean = true;
  public nroHabilitacion: string = "";
  public fechaHabAprobada: string = "";
  public fechaVencimientoHab: string = "";
  public bajaAdministrativa: string = "";

  public tramiteActividades: Array<any> = [];
  public tramiteActividadesNoEjercidas: Array<any> = [];
  public tramiteSocios: Array<any> = [];
}
